import * as types from './types'

export default{
  [types.CHANGE_FBDISPLAY]: ({commit}, payload) => {
    // console.log('FBDISPLAY:' +payload)
    commit(types.MUT_FBDISPLAY,payload)
  }
}
